<template>
    <rkm-modal
        :buttons="['cancel']"
        @save="$refs.Form.save()"
        extraLarge
        ref="Modal"
        title="Transferência de cota entre unidades"
    >
        <Form
            :data="data"
            :unidadeId="unidadeId"
            :infraestruturaId="infraestruturaId"
            :index="index"
            :item="item"
            :itemExame="itemExame"
            :cotaTipoId="cotaTipoId"
            :cotalaboratorio="cotalaboratorio"
            @save="handleExit"
            ref="Form"
        />
    </rkm-modal>
</template>

<script>
// Components.
import Form from './Form'

export default {
    components: { Form },
    data: () => ({
        index: null,
        item: null,
    }),
    methods: {
        open(item) {

            this.item = item

            this.$refs.Modal.show()
        },
        handleExit(data) {

            this.$emit('save', data)
        },
    },
    props: {
        data: { type: Object, required: true },
        itemExame: { type: Object, required: true },
        cotalaboratorio: { type: Object, required: true },
        unidadeId: { type: Number, default: null },
        infraestruturaId: { type: Number, default: null },
        cotaTipoId: { type: Number, required: true },
    }
}
</script>